import { useDataFetch } from '../../../hooks/use-data-fetch';


export const useInfluencerSettlements = () => {
  const { getData } = useDataFetch();
  const { data, isLoading, error, refetch } = getData(
    ['influencer-settlements'],
    '/settlements/user/influencer-bonuses'
  );

  const settlements = data?.data || [];

  // Calcular totales por moneda usando user_data.total_by_currency
  const getTotalsByCurrency = () => {
    const totals: Record<string, { points: number; value: number }> = {};
    
    settlements.forEach((settlement: any) => {
      // Nueva estructura: user_data.total_by_currency
      if (settlement.user_data?.total_by_currency) {
        Object.entries(settlement.user_data.total_by_currency).forEach(([currency, data]: [string, any]) => {
          if (!totals[currency]) {
            totals[currency] = { points: 0, value: 0 };
          }
          totals[currency].points += data.total_points || 0;
          totals[currency].value += data.total_value || 0;
        });
      }
    });

    // Filtrar solo monedas con valores mayores a 0
    const filteredTotals: Record<string, { points: number; value: number }> = {};
    Object.entries(totals).forEach(([currency, data]) => {
      if (data.value > 0 || data.points > 0) {
        filteredTotals[currency] = data;
      }
    });

    return filteredTotals;
  };

  const getActiveCurrencies = () => {
    const totalsByCurrency = getTotalsByCurrency();
    return Object.keys(totalsByCurrency);
  };

  const getTotalEarned = () => {
    const totalsByCurrency = getTotalsByCurrency();
    return Object.values(totalsByCurrency).reduce((sum, curr) => sum + curr.value, 0);
  };

  const getTotalsByPeriod = () => {
    return settlements.map((settlement: any) => {
      // Calcular totales por moneda para este período específico usando user_data.total_by_currency
      const currenciesByPeriod: Record<string, { points: number; value: number; point_value: number }> = {};
      let totalValue = 0;
      let totalPoints = 0;
      
      if (settlement.user_data?.total_by_currency) {
        Object.entries(settlement.user_data.total_by_currency).forEach(([currency, data]: [string, any]) => {
          if (data.total_value > 0 || data.total_points > 0) {
            currenciesByPeriod[currency] = {
              points: data.total_points || 0,
              value: data.total_value || 0,
              point_value: data.point_value || 0
            };
            totalValue += data.total_value || 0;
            totalPoints += data.total_points || 0;
          }
        });
      }

      return {
        period: settlement.period,
        total_value: totalValue,
        total_points: totalPoints,
        currencies_breakdown: currenciesByPeriod,
        currencies: Object.keys(currenciesByPeriod),
        status: settlement.status,
        paid_status: settlement.user_data?.paid_status || false,
        created_at: settlement.created_at,
        settlement_id: settlement.settlement_id,
        calculation_date: settlement.calculation_date,
        type: settlement.type,
        // Agregar datos completos para el modal
        user_data: settlement.user_data
      };
    });
  };

  return {
    settlements,
    isLoading,
    error,
    refetch,
    totalEarned: getTotalEarned(),
    totalsByCurrency: getTotalsByCurrency(),
    activeCurrencies: getActiveCurrencies(),
    totalsByPeriod: getTotalsByPeriod()
  };
};
